









































































































import Vue from "vue";
import { ref, computed, Ref } from "@vue/composition-api";
import AppCheckbox from "@/components/AppCheckbox.vue";
import Popup from "@/components/Popup.vue";
import SimpleItem from "./SimpleItem.vue";
import IconAndTextItem from "./IconAndTextItem.vue";
import { DropdownItemType } from "./items.type";
import { uniqueId } from "@/utils/uniqueId";
export default Vue.extend({
  components: {
    Popup,
    AppCheckbox,
  },
  props: {
    placeholder: {
      type: String,
      default: "Select...",
    },
    value: {
      type: Array,
    },
    includeSearch: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "simple",
    },
    openUp: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    multi: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const triggerId = uniqueId("dropdown");
    const isOpen = ref(false);

    const query = ref("");

    const selected: Ref<Map<number | string, DropdownItemType>> = ref(
      new Map()
    );

    const cmp = computed(() => {
      switch (props.type as string) {
        case "iconAndText":
          return IconAndTextItem;
        case "simple":
        default:
          return SimpleItem;
      }
    });

    const popup: Ref<{ close: (emitEvent?: boolean) => void }> = ref({
      close: () => {
        query.value = "";
      },
    });

    const onItemClicked = (item: DropdownItemType) => {
      if (props.multi) {
        if (selected.value.has(item.id)) {
          selected.value.delete(item.id);
        } else {
          selected.value.set(item.id, item);
        }
      } else {
        selected.value.clear();
        selected.value.set(item.id, item);
        popup.value.close();
        query.value = "";
      }
      emit("input", Array.from(selected.value.values()));
    };

    /**
     * @public
     */
    const close = (emitEvent = true) => {
      popup.value && popup.value.close(emitEvent);
      query.value = "";
    };

    const closePopup = () => {
      isOpen.value = false;
      query.value = "";
      emit("close");
    };

    const displayItems = computed(() => {
      if (query.value) {
        const term = query.value.toLowerCase();
        // @ts-ignore
        return props.items.filter(
          (item: { name: string }) => item.name.toLowerCase().search(term) > -1
        );
      } else {
        return props.items;
      }
    });

    /**
     * @public
     * */
    const setSelectdVal = (item: DropdownItemType) => {
      selected.value.clear();
      selected.value.set(item.id, item);
      popup.value.close();
      query.value = "";
      emit("input", Array.from(selected.value.values()));
    };
    return {
      query,
      triggerId,
      isOpen,
      cmp,
      selected,
      onItemClicked,
      popup,
      close,
      closePopup,
      displayItems,
      setSelectdVal,
    };
  },
});
